var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsername(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7273 3H1.27273C0.572727 3 0 3.6 0 4.33333V9.66667C0 10.4 0.572727 11 1.27273 11H12.7273C13.4273 11 14 10.4 14 9.66667V4.33333C14 3.6 13.4273 3 12.7273 3ZM6.36364 7.66667H4.45455V9.66667H3.18182V7.66667H1.27273V6.33333H3.18182V4.33333H4.45455V6.33333H6.36364V7.66667ZM9.22727 9C8.69909 9 8.27273 8.55333 8.27273 8C8.27273 7.44667 8.69909 7 9.22727 7C9.75545 7 10.1818 7.44667 10.1818 8C10.1818 8.55333 9.75545 9 9.22727 9ZM11.7727 7C11.2445 7 10.8182 6.55333 10.8182 6C10.8182 5.44667 11.2445 5 11.7727 5C12.3009 5 12.7273 5.44667 12.7273 6C12.7273 6.55333 12.3009 7 11.7727 7Z",
    fill: "#BEAEFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsername);
export default __webpack_public_path__ + "static/media/username.d11b0ba226a80bf57bb3cce3a18b00a8.svg";
export { ForwardRef as ReactComponent };